exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[disabled], html input[disabled] {\r\n    opacity:0.5 !important;\r\n}\r\ninput[type='checkbox'] {\r\n    width:23px !important;\r\n}\r\n.genPdfCol {\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/layout/transactions/transactions.component.css
// module id = 944
// module chunks = 31